import LabTestManager from "./LabTestManager";

export default function TestFromDoctors() {
    return (
        <LabTestManager filter="FromDoctor" />
    );
}